import styled from "styled-components";
import { Assets } from "../../common/styles/assets";



export const Wrapper = styled.div`
  width: 100%;
  height: 60vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 80px;

`;

export const Title = styled.h1`
  font-size: 24px;
  font-weight: 600;
  font-family: 'Inter', Arial, sans-serif;
  font-weight: bold;
  color: ${Assets.primaryColor};
  margin-bottom: 40px;
`;